import { PERIOD, SEARCH } from 'constants/FilterConstants';
import * as types from 'modules/chat/actionTypes';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {'text' | 'messageStatus' | 'period' | 'startDateTo' | 'startDateFrom'} ChatUIFiltersField */
/** @typedef {Record<ChatUIFiltersField, string | string[] | unknown>} ChatUIFiltersReducer */

const emptyState = {
  [SEARCH]: null,
  messageStatus: null,
  // Date filters
  [PERIOD]: 'ALL',
  startDateTo: null,
  startDateFrom: null,
};

const persistedValues = getPersistedFilters()?.filters?.chat;

const persistedFilters = Object.entries(persistedValues ?? {}).reduce((acc, [field, value]) => {
  if (field in emptyState) {
    return { ...acc, [field]: value };
  }
  return acc;
}, []);

const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_CHAT_FILTER]: filterAdapter.setFilter,
  [types.SET_CHAT_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_CHAT_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_CHAT_FILTER]: filterAdapter.removeFilter,
});
